export const cursorConfig = {
  node: {
    name: "node",
    dataUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="8" fill="none" stroke="black" stroke-width="2"/><circle cx="16" cy="16" r="1.5" fill="black"/></svg>',
    hotspotX: 16,
    hotspotY: 16,
  },
  beam: {
    name: "beam",
    dataUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M16 6 L26 16 L16 26 L6 16 Z" fill="none" stroke="black" stroke-width="2"/><circle cx="16" cy="16" r="1.5" fill="black"/></svg>',

    hotspotX: 16,
    hotspotY: 16,
  },
  prep: {
    name: "prep",
    dataUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><line x1="16" y1="4" x2="16" y2="16" stroke="black" stroke-width="2"/><line x1="4" y1="16" x2="28" y2="16" stroke="black" stroke-width="2"/><circle cx="16" cy="16" r="3" fill="white" stroke="black" stroke-width="1"/></svg>',

    hotspotX: 16,
    hotspotY: 16,
  },
  select: {
    name: "select",
    dataUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><defs><filter id="shadowSelect" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0.5" dy="0.5" stdDeviation="0.8" flood-opacity="0.3"/></filter></defs><g filter="url(%23shadowSelect)"><line x1="16" y1="4" x2="16" y2="28" stroke="black" stroke-width="2.5" stroke-linecap="round"/><line x1="4" y1="16" x2="28" y2="16" stroke="black" stroke-width="2.5" stroke-linecap="round"/><circle cx="16" cy="16" r="3" fill="black"/><circle cx="16" cy="16" r="5" fill="none" stroke="black" stroke-width="1.5" opacity="0.4"/></g></svg>',
    hotspotX: 16,
    hotspotY: 16,
  },
  divide: {
    name: "divide",
    dataUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="8" fill="none" stroke="black" stroke-width="2"/><circle cx="16" cy="16" r="1.5" fill="black"/><line x1="2" y1="16" x2="8" y2="16" stroke="black" stroke-width="1.8" stroke-linecap="round"/><line x1="24" y1="16" x2="30" y2="16" stroke="black" stroke-width="1.8" stroke-linecap="round"/></svg>',
    hotspotX: 16,
    hotspotY: 16,
  },
};

export type CursorType = keyof typeof cursorConfig;

export const getCursorStyle = (cursorType: CursorType | null): string => {
  if (!cursorType) return "auto";

  const cursor = cursorConfig[cursorType];
  return `url('${cursor.dataUrl}') ${cursor.hotspotX} ${cursor.hotspotY}, auto`;
};
